import { post, upload, get } from '@/api/request'

export const uploadUrl = '/api/solve-x-ai/file/put-file'

export const getAppConfig = () => {
    return post('/api/solve-x-ai/appconfig/appconfig', {
        remoteConfig: []
    })
}

export const checkIfNewUser = async () => {
    return post('/api/solve-x-ai/appconfig/checkuser')
}

export const uploadFile = async (formData: FormData, isStaticFile: boolean = true, onProgress?: (progress: { loaded: number; total: number; percent: number }) => void) => {
    return upload('/api/solve-x-ai/file/put-file?isStaticFile=' + (isStaticFile ? 1 : 0) + '&uploadTimeSpan=' + Date.now(), formData, {
        onUploadProgress: onProgress
    })
}

export const getAppstoreInfo = () => {
    return get('/api/solve-x-ai/appstore/info')
}
